import { render, staticRenderFns } from "./MdCategoryTag.vue?vue&type=template&id=dd1d3cee&scoped=true&"
import script from "./MdCategoryTag.vue?vue&type=script&lang=js&"
export * from "./MdCategoryTag.vue?vue&type=script&lang=js&"
import style0 from "./MdCategoryTag.vue?vue&type=style&index=0&id=dd1d3cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1d3cee",
  null
  
)

export default component.exports